import React from "react";
import { Image } from "react-bootstrap";
import RubricsModal from "./component/RubricsModal/RubricsModal";
import { PageHeader } from "CommonComponent";

const AppraisalProgressFormHeader = () => {
  const [modalShow, setModalShow] = React.useState(false);

  return (
    <>
      <PageHeader title="Appraisal Progress Form">
        <div className="d-flex align-items-center gap-3">
          <p className="font-13 font-weight-medium heading-color mb-0">
            Rubrics:
          </p>
          <button
            type="button"
            className="rubrics-btn"
            onClick={() => setModalShow(true)}
            aria-label="View rubrics"
          >
            <img src="/assets/images/rubrics-icon.svg" alt="" aria-hidden="true" />
          </button>
        </div>
      </PageHeader>
      <RubricsModal show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
};

export default AppraisalProgressFormHeader;
